import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiGift, FiExternalLink } = FiIcons;

const MuseumDonation = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-purple-900">
      <div className="container mx-auto px-6">
        <motion.div 
          className="max-w-6xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#ffc700] to-cyan-400 bg-clip-text text-transparent">
              Linda Roberts Gives Back
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Supporting the American Museum of Natural History
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <p className="text-gray-300 leading-relaxed text-lg">
                Linda Roberts is not only raising awareness about scams but also making a difference in her community. She donates 10% of her social media and advertisement profits to the American Museum of Natural History in New York City.
              </p>
              
              <p className="text-gray-300 leading-relaxed text-lg">
                Through this initiative, Linda combines her passion for education and philanthropy, supporting one of NYC's most iconic institutions. Her contributions help preserve the museum's mission of inspiring curiosity and advancing knowledge about our natural world.
              </p>

              <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                <SafeIcon icon={FiGift} className="text-2xl text-[#ffc700] mb-3" />
                <h4 className="font-bold text-white mb-2">Making an Impact</h4>
                <p className="text-gray-400">
                  Linda's commitment to giving back showcases her dedication to creating a positive impact beyond her work as a scam awareness advocate.
                </p>
              </div>

              <div className="flex items-center justify-start">
                <a 
                  href="https://www.amnh.org/join-support" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-[#ffc700] to-[#ffb700] hover:from-[#ffb700] hover:to-[#ffa700] text-black px-6 py-3 rounded-full font-bold text-sm transition-all duration-300 transform hover:scale-105 flex items-center gap-2 shadow-lg"
                >
                  <SafeIcon icon={FiHeart} className="text-lg" />
                  Support the Museum
                  <SafeIcon icon={FiExternalLink} className="text-sm" />
                </a>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="rounded-xl overflow-hidden shadow-lg border border-gray-700 hover:border-[#ffc700]/30 transition-all duration-300 group">
                  <div className="aspect-square">
                    <img 
                      src="https://berqwp-cdn.sfo3.cdn.digitaloceanspaces.com/cache/lrcs.nyc/wp-content/uploads/2025/01/image-jpg.webp" 
                      alt="American Museum of Natural History" 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
                <div className="rounded-xl overflow-hidden shadow-lg border border-gray-700 hover:border-[#ffc700]/30 transition-all duration-300 group">
                  <div className="aspect-square">
                    <img 
                      src="https://berqwp-cdn.sfo3.cdn.digitaloceanspaces.com/cache/lrcs.nyc/wp-content/uploads/2025/01/apex-stegosaurus.webp" 
                      alt="Stegosaurus exhibit at the American Museum of Natural History" 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
              </div>

              <div className="bg-gray-800 p-6 rounded-xl border border-[#ffc700]/30">
                <div className="flex items-start gap-3">
                  <SafeIcon icon={FiHeart} className="text-pink-500 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-bold text-white mb-2">Community Connection</h4>
                    <p className="text-gray-300">
                      "I've always loved the Museum of Natural History since I was a kid. It's a place that inspires wonder and education – two things I deeply value in my own work exposing scammers. Giving back to this iconic NYC institution is my way of supporting the community that's supported me."
                    </p>
                    <p className="text-[#ffc700] font-medium mt-2">- Linda Roberts</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MuseumDonation;